import { queryOptions, useQuery } from "@tanstack/react-query";

import { fetchSignInMethodsForEmail } from "services/firebase/auth";
import { getUserLinkedProviders } from "services/firebase/auth/ssoProvider";

import { usePrefetchQuery } from "seneca-common/utils/reactQuery/utils";

/**
 * TODO: This is intended as a temporary solution to differentiate between "emailLink" and "password" sign-in methods,
 * and should be removed once a backend flow for password reset is implemented.
 */
function isPasswordlessQueryOptions() {
  const providers = getUserLinkedProviders();
  const passwordProvider = providers.find(
    provider => provider.providerId === "password"
  );

  const email = passwordProvider?.email;

  return queryOptions({
    queryKey: ["authentication", "isPasswordless"],
    queryFn: () => fetchSignInMethodsForEmail(email!),
    select: signInMethods => {
      return (
        signInMethods.includes("emailLink") &&
        !signInMethods.includes("password")
      );
    },
    enabled: !!email
  });
}

export default function useIsPasswordless() {
  const { data: isPasswordless, isLoading } = useQuery(
    isPasswordlessQueryOptions()
  );

  return {
    isUserPasswordless: !!isPasswordless,
    isPasswordlessLoading: isLoading
  };
}

export function usePrefetchIsPasswordless() {
  usePrefetchQuery(isPasswordlessQueryOptions());
}
